// const apiEndpoint = 'https://test-backendbpms.promolife.lat/api';

// const photosEndpoint = process.env.REACT_APP_PHOTOS_ENDPOINT;

// console.log(process.env.NODE_ENV);
// console.log('despliegue');
// console.log(process.env.REACT_APP_PHOTOS_ENDPOINT);
// console.log(process.env.REACT_APP_API_ENDPOINT);

let apiEndpoint, photosEndpoint;
const ensureTrailingSlash = (url = '') => (url.endsWith('/') ? url : `${url}/`);
const sanitizePhotosEndpoint = (url = '') => ensureTrailingSlash(url).replace(/\/photos\/$/i, '/');

if (process.env.NODE_ENV === 'development') {
  //apiEndpoint = 'https://bpms-api.promo-connect.com.mx/api';
  //photosEndpoint = ensureTrailingSlash('https://bpms-api.promo-connect.com.mx/photos');
  apiEndpoint = 'http://127.0.0.1:8000/api';
  photosEndpoint = 'http://127.0.0.1:8000';
  // console.log('apiEndpoint', apiEndpoint);
  // console.log(photosEndpoint);
} else {
  apiEndpoint = process.env.REACT_APP_API_ENDPOINT;
  photosEndpoint = sanitizePhotosEndpoint(process.env.REACT_APP_PHOTOS_ENDPOINT);
  console.log(apiEndpoint);
  console.log(photosEndpoint);
}

export { apiEndpoint, photosEndpoint };
